import {ModelWithParent} from "FormBuilder/Core/Models/ModelWithParenth";
import {
    ConditionGroupOptions,
    ConditionLineOptions,
    ConditionOptionsBase, ElementUsedOptions
} from "FormBuilder/Fields/Core/ConditionOptions";
import {FBFieldBaseModel} from "FormBuilder/Fields/Core/FBFieldBase.Model";

export class ConditionModel extends ModelWithParent<ConditionOptionsBase,FBFieldBaseModel>{



}

export class ElementUsedModel extends ModelWithParent<ElementUsedOptions,ConditionModel>{

}


export class ConditionGroupsModel extends ModelWithParent<ConditionGroupOptions, ConditionModel>{

}



export class ConditionLineModel extends ModelWithParent<ConditionLineOptions,ConditionGroupsModel>
{

}



